import {
  DashboardOutlined,
  UserOutlined,
  CrownOutlined,
  MoneyCollectOutlined,
  TransactionOutlined,
  ShareAltOutlined,
  NotificationOutlined,
  AppstoreOutlined,
  FileSearchOutlined,
  ShoppingOutlined,
  CloudUploadOutlined,
  ApiOutlined,
  SecurityScanOutlined,
  CustomerServiceOutlined,
  UnorderedListOutlined,
  SettingOutlined,
  MessageOutlined,
} from '@ant-design/icons';

export const ADMIN_ROLES = {
  ADMIN: 'ADMIN',
  SUPER_ADMIN: 'SUPER_ADMIN',
};

export const adminRouteConfigs = [
  { key: '/admin/dashboard', label: '仪表盘', icon: DashboardOutlined, roles: [ADMIN_ROLES.ADMIN, ADMIN_ROLES.SUPER_ADMIN] },
  { key: '/admin/analytics', label: '使用统计', icon: DashboardOutlined, roles: [ADMIN_ROLES.SUPER_ADMIN] },
  { key: '/admin/users', label: '用户管理', icon: UserOutlined, roles: [ADMIN_ROLES.ADMIN, ADMIN_ROLES.SUPER_ADMIN] },
  { key: '/admin/risk-control', label: '风控中心', icon: SecurityScanOutlined, roles: [ADMIN_ROLES.ADMIN, ADMIN_ROLES.SUPER_ADMIN] },
  { key: '/admin/help-center', label: '帮助中心', icon: CustomerServiceOutlined, roles: [ADMIN_ROLES.ADMIN, ADMIN_ROLES.SUPER_ADMIN] },
  { key: '/admin/memberships', label: '会员管理', icon: CrownOutlined, roles: [ADMIN_ROLES.ADMIN, ADMIN_ROLES.SUPER_ADMIN] },
  { key: '/admin/rebates', label: '返利记录', icon: MoneyCollectOutlined, roles: [ADMIN_ROLES.ADMIN, ADMIN_ROLES.SUPER_ADMIN] },
  { key: '/admin/withdrawals', label: '提现审核', icon: TransactionOutlined, roles: [ADMIN_ROLES.ADMIN, ADMIN_ROLES.SUPER_ADMIN] },
  { key: '/admin/invites', label: '邀请管理', icon: ShareAltOutlined, roles: [ADMIN_ROLES.ADMIN, ADMIN_ROLES.SUPER_ADMIN] },
  { key: '/admin/notifications', label: '通知运营', icon: NotificationOutlined, roles: [ADMIN_ROLES.SUPER_ADMIN] },
  { key: '/admin/operations', label: '运营预览', icon: AppstoreOutlined, roles: [ADMIN_ROLES.SUPER_ADMIN] },
  { key: '/admin/curated-products', label: '精选商品', icon: ShoppingOutlined, roles: [ADMIN_ROLES.SUPER_ADMIN] },
  { key: '/admin/app-versions', label: '版本管理', icon: CloudUploadOutlined, roles: [ADMIN_ROLES.SUPER_ADMIN] },
  { key: '/admin/order-tracking', label: '订单追踪', icon: FileSearchOutlined, roles: [ADMIN_ROLES.ADMIN, ADMIN_ROLES.SUPER_ADMIN] },
  { key: '/admin/system-config', label: '系统配置', icon: SettingOutlined, roles: [ADMIN_ROLES.SUPER_ADMIN] },
  { key: '/admin/ai-safety', label: 'AI审核记录', icon: SecurityScanOutlined, roles: [ADMIN_ROLES.SUPER_ADMIN] },
  { key: '/admin/daily-messages', label: '今日寄语', icon: MessageOutlined, roles: [ADMIN_ROLES.SUPER_ADMIN] },
  { key: '/admin/taobao-api-usage', label: '淘宝调用明细', icon: UnorderedListOutlined, roles: [ADMIN_ROLES.SUPER_ADMIN] },
  { key: '/admin/taobao-integration', label: '淘宝授权', icon: ApiOutlined, roles: [ADMIN_ROLES.SUPER_ADMIN] },
];

export const canAccessAdminRoute = (admin, allowedRoles) => {
  const role = admin?.role;
  if (!role || !Array.isArray(allowedRoles) || allowedRoles.length === 0) {
    return false;
  }
  return allowedRoles.includes(role);
};

export const findFirstAccessibleRoute = (admin) => {
  const route = adminRouteConfigs.find((item) => canAccessAdminRoute(admin, item.roles));
  return route?.key || '/login';
};
